import React from 'react'
import PropTypes from 'prop-types'
import Grid from '@mui/material/Grid'
import { prop } from 'ramda'
import { useParams } from 'react-router-dom'

import { Button } from '~/components/Buttons'
import PageTitle from '~/components/PageTitle'
import Container, { Content, Header } from '~/components/Container'
import * as NAV from '~/constants/nav-titles'
import { RECEIVE_TABS } from '~/constants/tabs'
import History from '~/components/History'
import LoaderProvider from '~/components/Loader'

import DetailLineItems from './DetailLineItems'

import ReceiveTransferTabs from '../ReceiveStockTransfer/ReceiveTransferTabs'
import { COMPLETED } from '../../constants'

function ReceiveTransferDetail (props) {
  const {
    pageTitle,
    pageTitleLoading,
    receiveHistory,
    isLoading,
    handleReceive,
    completeDisabled,
    values,
    onComplete,
    getVariantDetail
  } = props

  const { guid, tab } = useParams()

  const receivingStatus = prop('receivingStatus', values)
  const lineItems = prop('lineItems', values)

  const disabled = (
    isLoading ||
    completeDisabled ||
    receivingStatus === COMPLETED
  )

  return (
    <LoaderProvider isLoading={isLoading}>
      <Container>
        <Header>
          <PageTitle
            pageTitle={pageTitle}
            pageTitleLoading={pageTitleLoading}
            parentTitle={NAV.RECEIVE}
            rightButton={(
              <>
                <Button
                  variant="contained"
                  data-cy="receive"
                  type="button"
                  onClick={handleReceive}
                >
                  Receive
                </Button>
                <Button
                  disabled={disabled}
                  variant="contained"
                  data-cy="complete"
                  onClick={onComplete}
                >
                  Complete
                </Button>
              </>
            )}
          />
        </Header>

        <Content>
          <ReceiveTransferTabs value={tab} guid={guid} />
          <Grid container={true} spacing={3}>
            <Grid item={true} xs={12}>
              {tab === RECEIVE_TABS.GENERAL && (
                <DetailLineItems
                  isLoading={isLoading}
                  lineItems={lineItems}
                  getVariantDetail={getVariantDetail}
                />
              )}
              {tab === RECEIVE_TABS.HISTORY && <History history={receiveHistory} />}
            </Grid>
          </Grid>
        </Content>
      </Container>
    </LoaderProvider>
  )
}

ReceiveTransferDetail.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  pageTitleLoading: PropTypes.bool.isRequired,
  completeDisabled: PropTypes.bool.isRequired,
  pageTitle: PropTypes.node.isRequired,
  values: PropTypes.object.isRequired,
  receiveHistory: PropTypes.object.isRequired,
  handleReceive: PropTypes.func.isRequired,
  onComplete: PropTypes.func.isRequired,
  getVariantDetail: PropTypes.func.isRequired
}

export default ReceiveTransferDetail
